import {sortById} from "../../helpers";

const state = {
  messages: [],
  quotes: [],
  menuOpened: false,
  scrolling: false,
  gettingOldMsgs: false,
  historyCallback: null,
  newMessageReceived: false,
}

const getters = {
  getAttentions (state) {
    return state.messages.filter( msg => msg.isImportant).sort(sortById)
  },
  getMessages (state) {
    return state.messages.sort(sortById)
  },
  getQuotes (state) {
    return state.quotes
  },
  getQuestions (state) {
    return state.messages.filter( msg => msg.isQuestion).sort(sortById)
  },
  getMenuOpened(state) {
    return state.menuOpened
  },
  getIsScrolling(state) {
    return state.scrolling
  },
  getGettingOldMsgs(state) {
    return state.gettingOldMsgs
  },
  getHistoryCallback(state) {
    return state.historyCallback
  },
  getNewMessageReceived(state) {
    return state.newMessageReceived
  },
}

const mutations = {
  createMessage (state, message) {
    for (const msg of state.messages) {
      if (message.id === msg.id) return
    }
    state.messages.push(message)
  },
  createQuote (state, message) {
    for (const msg of state.quotes) {
      if (message.id === msg.id) return
    }
    state.quotes.push(message)
  },
  markAttention(state, message) {
    let found = false
    for (const msg of state.messages) {
      if (message.id === msg.id) {
        msg.isImportant = true
        found = true
        return
      }
    }
    // FIXME: нельзя добавлять сообщение, надо исправить логику обновления статусов сообщений
    if (!found) state.messages.push(message)
  },
  unmarkAttention (state, message) {
    for (const msg of state.messages) {
      if (message.id === msg.id) {
        msg.isImportant = false
        return
      }
    }
  },
  markDeleted (state, message) {
    state.messages = state.messages.filter(msg => msg.id !== message.id)
  },
  markQuestion (state, message) {
    let found = false
    for (const msg of state.messages) {
      if (message.id === msg.id) {
        msg.isQuestion = true
        found = true
        return
      }
    }
    // FIXME: нельзя добавлять сообщение, надо исправить логику обновления статусов сообщений
    if (!found) state.messages.push(message)
  },
  unmarkQuestion (state, message) {
    for (const msg of state.messages) {
      if (message.id === msg.id) {
        msg.isQuestion = false
        return
      }
    }
  },
  likeMessage (state, {message, getters}) {
    for (const msg of state.messages) {
      if (parseInt(message.msg) === msg.id) {
        msg.likes++
        if (msg.sender.uid === getters.getMyId ) msg.liked = true
        return
      }
    }
  },
  dislikeMessage (state, {message, getters}) {
    for (const msg of state.messages) {
      if (parseInt(message.msg) === msg.id) {
        msg.likes--
        if (msg.sender.uid === getters.getMyId ) msg.liked = false
        return
      }
    }
  },
  truncateMessageList (state) {
    state.messages = []
  },
  truncateQuoteList (state) {
    state.quotes = []
  },
  setMenuOpened (state, newState) {
    state.menuOpened = newState
  },
  setScrolling (state, value) {
    state.scrolling = value
  },
  setGettingOldMsgs (state, value) {
    state.gettingOldMsgs = value
  },
  setHistoryCallback (state, value) {
    state.historyCallback = value
  },
  setNewMessageReceived (state, value) {
    state.newMessageReceived = value
  }
}

const actions = {
  prepareMessage ({state, commit, getters}, response) {
    const isQuestion = () => {
      if (response.type === 'question') return true
      // первый бит - это вопрос
      const bit = 0
      return (response.attributes & (1 << bit))
    }
    const isImportant = () => {
      if (response.type === 'important') return true
      // второй бит - это важное сообщение
      const bit = 1
      return (response.attributes & (1 << bit))
    }
    const msg = {
      id: response.id,
      sender: {
        author: response.author,
        uid: response.author_uid,
        avatar: response.author_avatar
      },
      msg: response.body,
      deleted: response.deleted,
      timestamp: response.timestamp,
      type: response.type,
      isQuestion: isQuestion(),
      isImportant: isImportant(),
      likes: response.likes,
      liked: response.liked,
    }
    if (response.quote && response.quote > 0) {
      const quotedMsg = state.quotes.find(m => m.id === response.quote) || state.messages.find(m => m.id === response.quote)
      if (quotedMsg) msg.quote = {msg: quotedMsg.msg, author: quotedMsg.sender.author, id: quotedMsg.id}
    }

    switch (response.type) {
      case 'important':
        commit('markAttention', msg)
        break
      case 'unimportant':
        commit('unmarkAttention', msg)
        break
      case 'deleted':
        commit('markDeleted', msg)
        break
      case 'question':
        commit('markQuestion', msg)
        break
      case 'not_question':
        commit('unmarkQuestion', msg)
        break
      case 'like':
        commit('likeMessage', {message:msg, getters})
        break
      case 'dislike':
        commit('dislikeMessage', {message:msg, getters})
        break
      case 'quote':
        commit('createQuote', msg)
        commit('createMessage', msg)
        break
      default:
        commit('createMessage', msg)
    }
  },
  markQuestion (context, {message}){
    context.commit('markQuestion', {message})
  },
  truncateMessageList (context) {
    context.commit('truncateMessageList')
  },
  truncateQuoteList (context) {
    context.commit('truncateQuoteList')
  },
  setMenuOpened(context, newState) {
    context.commit('setMenuOpened', newState)
  },
  setScrolling(context, newState) {
    context.commit('setScrolling', newState)
  },
  setGettingOldMsgs(context, newState) {
    context.commit('setGettingOldMsgs', newState)
  },
  setHistoryCallback(context, newState) {
    context.commit('setHistoryCallback', newState)
  },
  setNewMessageReceived(context, newState) {
    context.commit('setNewMessageReceived', newState)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
